import { login } from '@/api/login'
import { init } from '@/api/init'
import { status } from '@/api/status'
import { register } from '@/api/register'
import { returnMsg } from '@/utils'
import { theme } from '@/utils/theme'

export default {
  login ({ commit }, params) {
    return new Promise((resolve, reject) => {
      login(params).then(res => {
        resolve(res.data)
      }).catch(() => {
        resolve(returnMsg())
      })
    })
  },
  register ({ commit }, params) {
    return new Promise((resolve, reject) => {
      register(params).then(res => {
        resolve(res.data)
      }).catch(() => {
        resolve(returnMsg())
      })
    })
  },
  getInit ({ commit }) {
    return new Promise((resolve, reject) => {
      init().then(res => {
        if (!res.data.error_code) {
          // 改掉圣宏uitype
          if (process.env.VUE_APP_UITYPE === '6') {
            res.data.data.ui_type = 6
          }
          if (process.env.VUE_APP_UITYPE === '7') {
            res.data.data.ui_type = 7
          }
          commit('SET_INIT', res.data.data)
          commit('SET_THEMECONFIG', theme[res.data.data.ui_type].theme)
          commit('SET_ISINIT', true)
          if (res.data.data.game_info.name) document.title = res.data.data.game_info.name
        }
        resolve(res.data)
      }).catch(() => {
        resolve(returnMsg())
      })
    })
  },
  getStatus ({ commit }) {
    return new Promise((resolve, reject) => {
      status().then(res => {
        if (!res.data.error_code) {
          commit('SET_STATUS', res.data.data)
        }
        resolve(res.data)
      }).catch(() => {
        resolve(returnMsg())
      })
    })
  }
}
